module.exports = __webpack_public_path__ + "img/icon-xuangu2_00a8b.png";